import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useMedia } from "use-media";
import { ReactComponent as GithubIcon } from "../icons/github.svg";
import { ReactComponent as HomeIcon } from "../icons/home.svg";
import { ReactComponent as LinkedInIcon } from "../icons/linkedin.svg";
import { ReactComponent as MailIcon } from "../icons/mail.svg";
import { ReactComponent as MediumIcon } from "../icons/medium.svg";
import { ReactComponent as PdfIcon } from "../icons/pdf.svg";
import { ReactComponent as WorkIcon } from "../icons/work.svg";
import { ReactComponent as AboutIcon } from "../icons/about.svg";
import resume from "../resume/resume.pdf";

const Navigation = (props) => {
  const isMobile = useMedia({ maxWidth: 768 });
  const [showNav, setShowNav] = useState(false);

  const [tooltipPosition, setTooltipPosition] = useState(
    isMobile ? "top" : "left"
  );

  const { pathname } = useLocation();

  const isHome = pathname === "/";

  const navClass = isHome ? "nav__home" : "nav__other";
  const iconClass = isHome ? "icon__home" : "icon__work";

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: isHome ? "#499c9b" : "#397976",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: isHome ? "#499c9b" : "#397976",
      color: isHome ? "#1a2432" : "#f7f7f7",
      fontFamily: `"Spartan", sans-serif`,
      paddingTop: "0.5rem",
      marginBottom: "1rem",
    },
  }));

  useEffect(() => {
    let timeoutId;
    if (props.init) {
      timeoutId = setTimeout(() => {
        setShowNav(true);
      }, 500);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [props.init]);

  useEffect(() => {
    setTooltipPosition(isMobile ? "top" : "left");
  }, [isMobile]);

  const keyDownHideNavHandler = (e) => {
    if (e.keyCode === 13) {
      setShowNav(false);
    }
  };

  const hideNav = () => {
    setShowNav(false);
  };
  return (
    <header>
      {showNav && (
        <nav className={navClass}>
          <ul>
            {pathname !== "/" && (
              <li>
                <StyledTooltip title="Home" placement={tooltipPosition}>
                  <Link
                    to="/"
                    onClick={hideNav}
                    onKeyDown={keyDownHideNavHandler}
                    tabIndex="0"
                  >
                    <HomeIcon className={iconClass} />
                  </Link>
                </StyledTooltip>
              </li>
            )}
            {pathname !== "/work" && (
              <li>
                <StyledTooltip title="My work" placement={tooltipPosition}>
                  <Link
                    to="/work"
                    onClick={hideNav}
                    onKeyDown={keyDownHideNavHandler}
                    tabIndex="0"
                  >
                    <WorkIcon className={iconClass} />
                  </Link>
                </StyledTooltip>
              </li>
            )}
            {pathname !== "/about" && (
              <li>
                <StyledTooltip title="About me" placement={tooltipPosition}>
                  <Link
                    to="/about"
                    onClick={hideNav}
                    onKeyDown={keyDownHideNavHandler}
                    tabIndex="0"
                  >
                    <AboutIcon className={iconClass} />
                  </Link>
                </StyledTooltip>
              </li>
            )}
            <li>
              <StyledTooltip title="GitHub" placement={tooltipPosition}>
                <a
                  href="https://github.com/Lada496"
                  target="_blank"
                  rel="noreferrer"
                >
                  <GithubIcon className={iconClass} />
                </a>
              </StyledTooltip>
            </li>
            <li>
              <StyledTooltip title="LinkedIn" placement={tooltipPosition}>
                <a
                  href="https://www.linkedin.com/in/yukomurayama"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedInIcon className={iconClass} />
                </a>
              </StyledTooltip>
            </li>
            <li>
              <StyledTooltip title="Medium" placement={tooltipPosition}>
                <a
                  href="https://medium.com/@lada496"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MediumIcon className={iconClass} />
                </a>
              </StyledTooltip>
            </li>
            <li>
              <StyledTooltip title="Resume" placement={tooltipPosition}>
                <a href={resume} target="_blank" rel="noreferrer">
                  <PdfIcon className={iconClass} />
                </a>
              </StyledTooltip>
            </li>
            <li>
              <StyledTooltip title="E-mail" placement={tooltipPosition}>
                <a href="mailto: yukomurayama496@gmail.com">
                  <MailIcon className={iconClass} />
                </a>
              </StyledTooltip>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};
export default React.memo(Navigation);
